module.exports = __webpack_public_path__ + "img/bishuiwan.c8620695.jpg";